<template>
  <div class="big testDoctorPrescribing">
    <div class="page_title">医生评价审核</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 审核状态 -->
          <div class="item">
            <span>审核状态</span>
            <div class="item-content">
              <el-select
                v-model="evaluateCheckForm.status"
                placeholder="请选择"
                clearable
                size="small"
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in status_option"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 评价时间 -->
          <div class="item">
            <span style="width: 70px">评价时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="evaluateCheckForm.evaluate_date"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 审核时间 -->
          <div class="item">
            <span style="width: 70px">审核时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="evaluateCheckForm.check_date"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 审核人 -->
          <div class="item">
            <span>审核人</span>
            <div class="item-content">
              <el-input
                v-model="evaluateCheckForm.admin_user_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="审核人"
              ></el-input>
            </div>
          </div>

          <!-- 评分范围 -->
          <div class="item">
            <span style="width: 70px">评分范围</span>
            <div class="item-content">
              <el-input-number
                v-model="evaluateCheckForm.evaluate_start"
                size="small"
                :min="0"
                :max="5"
                :precision="1"
                :controls="false"
                clearable
              ></el-input-number>
              ~
              <el-input-number
                v-model="evaluateCheckForm.evaluate_end"
                size="small"
                :min="0"
                :max="5"
                :precision="1"
                :controls="false"
                clearable
              ></el-input-number>
            </div>
          </div>

          <!-- 评价类型 -->
          <div class="item">
            <span>评价类型</span>
            <div class="item-content">
              <el-select
                v-model="evaluateCheckForm.evaluate_type"
                placeholder="请选择"
                clearable
                size="small"
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in evaluate_type_option"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="evaluateCheckForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span>医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="evaluateCheckForm.doctor_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生手机号"
              ></el-input>
            </div>
          </div>

          <!-- 评价内容是否为空 -->
          <div class="item">
            <span style="width: 120px">评价内容是否为空</span>
            <div class="item-content" style="padding-top: 4px">
              <el-radio-group
                v-model="evaluateCheckForm.is_evaluate_content"
                @change="getList"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="addData"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1743') : false
              "
              >导入</el-button
            >
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="batchCheckUserEvaluate"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1142') : false
              "
              >批量审核</el-button
            >
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'user_info'">
                  <div>{{ scope.row.nick_name }}</div>
                  <div>{{ scope.row.patient_phone }}</div>
                </div>

                <div v-else-if="item.prop == 'patient_info'">
                  <div>{{ scope.row.user_name }}</div>
                </div>

                <div v-else-if="item.prop == 'doctor_info'">
                  <div>{{ scope.row.doctor_name }}</div>
                  <div>{{ scope.row.doctor_phone }}</div>
                </div>

                <div v-else-if="item.prop == 'evaluate_type'">
                  {{ scope.row[item.prop] | evaluateTypeText }}
                </div>

                <div v-else-if="item.prop == 'diagnosis_desc'">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.diagnosis_desc"
                    placement="top-start"
                  >
                    <div class="multiline-ellipsis">
                      {{ scope.row.diagnosis_desc }}
                    </div>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>

                <div v-else-if="item.prop == 'check_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="checkUserEvaluate(scope.row.ev_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1141')
                      : false
                  "
                  >审核</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="toDetail(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1744')
                      : false
                  "
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <ImportData :isFlag="importData" @refreshData="getList"></ImportData>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import systemWarning from "@/api/systemWarning.js";
import doctor from "@/api/doctor.js";
import Pagination from "@/components/Pagination/index";
import ImportData from "./ImportData.vue";
export default {
  components: {
    Pagination,
    ImportData,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      evaluateCheckForm: {
        status: 0,
        evaluate_date: [],
        check_date: [],
        admin_user_name: "",
        evaluate_start: undefined,
        evaluate_end: undefined,
        evaluate_type: 0,
        doctor_name: "",
        doctor_phone: "",
        is_evaluate_content: 0,
      },
      status_option: [
        {
          label: "待审核",
          value: 0,
        },
        {
          label: "已通过",
          value: 1,
        },
        {
          label: "不通过",
          value: 2,
        },
      ],
      evaluate_type_option: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "问诊评价",
          value: 1,
        },
        {
          label: "开方评价",
          value: 2,
        },
      ],
      tableHeader: [
        {
          label: "用户",
          prop: "user_info",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "患者姓名",
          prop: "patient_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生",
          prop: "doctor_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "评价类型",
          prop: "evaluate_type",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "病情描述/主诉",
          prop: "diagnosis_desc",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "评价分数",
          prop: "evaluate",
          width: "110",
          align: "center",
          fixed: false,
        },
        {
          label: "评价标签",
          prop: "evaluate_label",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "评价内容",
          prop: "evaluate_content",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "评价时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "审核状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "审核时间",
          prop: "check_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "审核人",
          prop: "admin_user_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      multipleSelection: [],
      importData: false,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    evaluateTypeText(val) {
      switch (val) {
        case 1:
          return "问诊评价";
        case 2:
          return "开方评价";
      }
    },
    statusText(val) {
      switch (val) {
        case 0:
          return "待审核";
        case 1:
          return "已通过";
        case 2:
          return "不通过";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    scTimeOptions() {
      let arr = [];
      for (let i = 1; i <= 30; i++) {
        arr.push({
          value: i,
          label: `${i}天`,
        });
      }
      return arr;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.evaluateCheckForm.evaluate_date = [start, end];
    },
    getList() {
      let params = Object.assign(this.pagination, this.evaluateCheckForm);
      params = _.omit(params, ["evaluate_date", "check_date"]);
      let check_date = this.evaluateCheckForm.check_date;
      let evaluate_date = this.evaluateCheckForm.evaluate_date;
      params["check_start_date"] = check_date ? check_date[0] : "";
      params["check_end_date"] = check_date ? check_date[1] : "";
      params["evaluate_start_date"] = evaluate_date ? evaluate_date[0] : "";
      params["evaluate_end_date"] = evaluate_date ? evaluate_date[1] : "";

      this.tableLoading = true;
      doctor.getUserEvaluateLog(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    //审核
    checkUserEvaluate(id) {
      this.$confirm("是否审核通过?", "审核", {
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
        distinguishCancelAndClose: true,
      })

        .then((res) => {
          let data = {
            ev_id: id,
            status: 1,
          };
          this.axios
            .post("platform/doctor/checkUserEvaluate", data)
            .then((res) => {
              this.getList();
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let data = {
              ev_id: id,
              status: 2,
            };
            this.axios
              .post("platform/doctor/checkUserEvaluate", data)
              .then((res) => {
                this.getList();
              });
          }
        });
    },
    //批量审核
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchCheckUserEvaluate() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择数据");
        return;
      }
      let ev_ids = this.multipleSelection.map((ele) => {
        return ele.ev_id;
      });
      this.$confirm("是否审核通过?", "审核", {
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
        distinguishCancelAndClose: true,
      })
        .then((res) => {
          let data = {
            ev_ids,
            status: 1,
          };
          console.log(data);
          this.axios
            .post("platform/doctor/batchCheckUserEvaluate", data)
            .then((res) => {
              this.getList();
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let data = {
              ev_ids,
              status: 2,
            };
            this.axios
              .post("platform/doctor/batchCheckUserEvaluate", data)
              .then((res) => {
                this.getList();
              });
          }
        });
    },
    //导入数据
    addData() {
      this.importData = !this.importData;
    },
    toDetail(row) {
      this.$router.push({
        path: "/home/doctor/evaluatedetail",
        query: {
          doctor_name: row.doctor_name,
          doctor_phone: row.doctor_phone,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.testDoctorPrescribing {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
